import './loader.scss'

function Loader({ loading }) {
  if (!loading) return null;

  return (
    <div className="overlay">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
